import { Pipe, PipeTransform } from '@angular/core';
import { RolloutProgressReportEntities } from '../../shared/self-inspection-reports/service/entities';
import {
  DistributionPointProperties,
  PointType,
} from '../span-progress-entities';

@Pipe({
  name: 'kpReportStatus',
  standalone: false,
})
export class KpReportStatusPipe implements PipeTransform {
  transform(
    point: DistributionPointProperties,
    pointStatuses: Record<
      string,
      RolloutProgressReportEntities.v3.ReportStatus
    >,
  ): RolloutProgressReportEntities.v3.ReportStatus | undefined {
    return point.markerTypeId === PointType.DuctPoint
      ? pointStatuses[point.id]
      : undefined;
  }
}
